<div class="modal" role="dialog" aria-modal="true">
  <div class="modal-content">
    <div class="modal-header">
      <div class="icon-container icon-success" *ngIf="data.status == 'success'">
        ✔
      </div>
      <div class="icon-container icon-warning" *ngIf="data.status == 'warning'">
        ⚠
      </div>
      <div class="icon-container icon-error" *ngIf="data.status == 'error'">
        ✖
      </div>
      <div class="icon-container icon-info" *ngIf="data.status == 'info'">
        ℹ
      </div>
      <!-- <h3 class="mb-0">{{ data.title }}</h3> -->
    </div>
    <div class="modal-body pb-0">
      <p>{{ data.content }}</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="onCloseDialog(false)">{{ data.okBtnText }}</button>
      <button *ngIf="data.showCloseBtn" class="btn btn-primary" (click)="onCloseDialog(true)">{{ data.closeBtnText
        }}</button>
    </div>
  </div>
</div>